// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3spQh","row":"styles_row__1FMv8"};